// Domicilio escrito de un legajo editable desde la consola de UCORP (PP-72).
// Desde PP-69 lo escriben la planilla y el manifiesto, y lo lee solo el
// proveedor en la hoja de ruta de un viaje asignado y vigente. Regla 10: un
// dato configurable tiene CRUD con auditoria, para corregirlo sin reimportar.
//
// Es dato personal: solo el editor (ucorp_admin) lo lee y lo escribe, cada
// lectura y cada escritura quedan en admin_audit y ninguna fila lleva el
// texto (solo si habia, si hay y si cambio). Editarlo no geocodifica ni mueve
// las coordenadas del legajo (ADR-022): describe el punto que ya tiene.
import { z } from "zod";
import { RecordId, SiteId } from "./common.js";
/** Tope del domicilio escrito, el mismo de la importacion de planillas (PP-69). */
export const RECORD_HOME_ADDRESS_MAX = 300;
export const RecordHomeAddressResponse = z
    .object({
    siteId: SiteId,
    record: RecordId,
    homeAddress: z.string().min(1).max(RECORD_HOME_ADDRESS_MAX).nullable().openapi({
        description: "Domicilio escrito (calle, numero y localidad) con los espacios normalizados. null: el legajo no tiene.",
    }),
})
    .strict()
    .openapi("RecordHomeAddressResponse", {
    description: "Domicilio escrito del legajo, sin ningun otro dato personal (ni nombre, ni telefono, ni coordenadas).",
});
export const UpdateRecordHomeAddressRequest = z
    .object({
    homeAddress: z.string().max(RECORD_HOME_ADDRESS_MAX).openapi({
        description: "Texto nuevo. La API normaliza los espacios como la importacion; vacio o solo espacios borra el domicilio escrito. Hasta 300 caracteres.",
    }),
})
    .strict()
    .openapi("UpdateRecordHomeAddressRequest", {
    description: "Reemplaza el domicilio escrito del legajo. No geocodifica ni cambia las coordenadas. Auditado sin el texto; rige en la proxima lectura de la hoja de ruta del proveedor.",
});
//# sourceMappingURL=record-home-address.js.map